// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import agentWarning from 'app/images/agentWarning.svg';

import type { AgentBadge_agent } from './__generated__/AgentBadge_agent.graphql';

type Props = {
  agent: AgentBadge_agent
};

function AgentBadge({ agent }: Props) {
  if (!agent.organization) {
    return null;
  }

  return (
    <React.Fragment>
      <a href={`/organizations/${agent.organization.slug}/agents/${agent.uuid}`}>
        <i className="fa fa-cube mr1" />
        {agent.name}
      </a>{agent.versionHasKnownIssues ? (
        <span aria-label="Upgrade Required — this agent has known issues">
          <img src={agentWarning} className="ml1 inline" />
        </span>
      ) : null}
    </React.Fragment>
  );
}

export default createFragmentContainer(AgentBadge, {
  agent: graphql`
    fragment AgentBadge_agent on Agent {
      name
      uuid
      version
      versionHasKnownIssues
      organization {
        slug
      }
    }
  `
});

